import React, { Component } from "react";
import IntroSection from "components/intro-section/IntroSection";
import "./Transizione.scss";
import { ReactComponent as SquareOut } from "icons/square-out.svg";

const format = (title) => {
  let arr = [];
  let exludeWords = ["e", "di"];
  arr = title.split("-");
  return arr
    .map((word, i) => {
      return exludeWords.includes(word) && i !== 0
        ? [word]
        : word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};

const boxInputs = [
  {
    title: "Accountability per la Transizione",
    body: "Evidenza il contributo delle Utilities alla Transizione ecologica e digitale ed al raggiungimento degli SDGs",
    color: "#016fc0",
  },
  {
    title: "Decarbonizzazione & Circularity",
    body: "Progettare, lanciare e sviluppare un Hub di competenze specialistiche sulla decarbonizzazione e sull'economia circolare che favorisca lo scambio di esperienze fra le associate",
    color: "#6b179e",
  },
  {
    title: "Finanza per la Transizione",
    body: "Presidiare i rischi e le opportunità connessi alla strategia UE sulla finanza sostenibile e, in particolare, alla tassonomia, ai benchmark di carbonio, ai green bond",
    color: "#01ae48",
  },
  {
    title: "Purpose aziendale",
    body: "Lanciare una riflessione sul Purpose delle aziende di pubblica utilità al fine di promueve una crescente integrazione nel modello di business tra innovazione, sostenibilità e valore condiviso per gli stakeholder",
    color: "#f19004",
  },
];

export default class Transizione extends Component {
  render() {
    return (
      <div className="transizione-page">
        <IntroSection
          category={format(this.props.match.url.split("/")[1])}
          subsector={format(this.props.match.url.split("/")[2])}
          subsubsector={format(this.props.match.url.split("/")[4])}
        />
        <div className="container pad-mobile">
          <div className="title">
            <h1 style={{ marginBottom: 0 }}>Utilitalia per la Transizione</h1>
            <p>Il progetto</p>
          </div>
          <p>
            La Federazione ad inizio del 2021 ha predisposto il piano{" "}
            <span>Utilitalia per la transizione</span> proponendo alle Associate
            di essere partner attivi in un'azione di sistema. Utilitalia intendo
            essere un{" "}
            <span>
              attore centrale nella transizione verso un'economia innovativa,
              digitale, sostenibile, fondata su criteri di circolarità e di
              basso impatto carbonico
            </span>
            : ciò a vantaggio delle proprie Associate, dei loro stakeholder e
            del sistema economico e sociale del Paese.
          </p>

          <div className="box-container" style={{ padding: 16 }}>
            <div className="box-row">
              {boxInputs.map((box) => (
                <div className="box">
                  <h4 style={{ color: box.color, marginBottom: 8 }}>
                    {box.title}
                  </h4>
                  <div
                    style={{
                      borderLeftColor: box.color,
                      borderLeftWidth: 5,
                      borderLeftStyle: "solid",
                      paddingLeft: 8,
                      height: 148,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <p>{box.body}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="box-row" style={{ marginTop: 12 }}>
              <div style={{ flex: 3 }}>
                <div className="squared-box">
                  <p>
                    Diretto riferimento agli ambiti del{" "}
                    <span>
                      <i>UE Green Deal</i> e del <i>Green Deal italiano</i>{" "}
                    </span>
                    (e alla loro implementazione), nonchè del{" "}
                    <i>Piano europeo per la finanza sostenibile,</i> cosi come
                    confermati nella <i>Roadmap for recovery</i> (post-COVID)
                  </p>
                </div>
              </div>
              <div style={{ flex: 1, marginLeft: 32 }}>
                <div className="squared-box">
                  <p>
                    Connotazione <b>fondativa e transversale</b> da rileggere
                    alla luce delle trasformazioni in atto sui merceti, della
                    rilevanza delle{" "}
                    <b>esternalità positive generate dal comparto</b> e
                    dall'obiettivo del successo sostenibile che orienta
                    l'attività d'impresa
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="team-box">
              <h3>Coordinamento Progetto</h3>
              <p>Maria Gerarda Mocella</p>
              <h3>Team</h3>
              <p>Andrea Bordin</p>
              <p>Luigi Joseph del Giacco</p>
              <p>Andrea di Piazza</p>
              <p>Mattia Galipò</p>
              <p>Gaia Rodriquez</p>
              <p>Valeria Zingarelli</p>
            </div>
            <div className="external-link-box">
              <a
                className="external-link"
                href="http://eventi.utilitalia.it/Sostenibilita_2022.htm"
              >
                La Sostenibilità nel Sistema Utilitalia
                <SquareOut width={18} />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
